/**
 * Creates a new step of the given type, copying common fields from the existing step.
 */
export function createStepByType(
    stepType: PipelineStep['type'],
    existingStep: PipelineStep
): PipelineStep {
    const common = {
        name: existingStep.name,
        description: existingStep.description,
        editorSettings: existingStep.editorSettings,
        analyticsSettings: existingStep.analyticsSettings,
        logsMsgs: existingStep.logsMsgs,
        transitions: existingStep.transitions,
    };

    switch (stepType) {
        case 'CREATE_SURVEY_LINK':
            return {
                type: 'CREATE_SURVEY_LINK',
                ...common,
                surveyName: '',
                answerLimitIsVar: false,
                answerLimitValue: 1,
                answerLimitVarId: '',
                surveyRefTargetVarId: '',
                responsesCounterTargetVarId: '',
                surveyIdIsVar: false,
                surveyIdVarId: '',
                surveyId: '',
                surveyParams: [],
                surveyDataSources: [],
                urlTargetVarId: '',
                platform: undefined,
            } as PipelineStep;
        case 'FINISH':
            return { type: 'FINISH', ...common } as PipelineStep;
        case 'EMPTY':
            return { type: 'EMPTY', ...common } as PipelineStep;
        case 'GENERATE_STORY':
            return {
                type: 'GENERATE_STORY',
                ...common,
                processingType: 'static',
                applicationName: '',
                storyName: '',
                storyParams: [],
                urlTargetVarId: '',
                storyId: { isFromVar: false, varId: '', constValue: '' },
                storyCode: { isFromVar: false, varId: '', constValue: '' },
                dataSources: [],
            } as PipelineStep;
        case 'GET_ANSWER_VALUES':
            return {
                type: 'GET_ANSWER_VALUES',
                ...common,
                recordIndex: 0,
                surveyRefVarId: '',
                requestedData: [],
            } as PipelineStep;
        case 'MODERATOR_INPUT':
            return {
                type: 'MODERATOR_INPUT',
                ...common,
                targetVarId: '',
                valueOptions: [],
            } as PipelineStep;
        case 'EXTERNAL_REQUEST':
            return {
                type: 'EXTERNAL_REQUEST',
                ...common,
                requestType: 'cycle_update',
                requestUrl: '',
                script: '',
                handler: '',
                payload: [],
                responseTargetVarId: '',
            } as PipelineStep;
        case 'SEND_MESSAGE':
            return {
                type: 'SEND_MESSAGE',
                ...common,
                message: '',
                phoneNumberVarId: '',
                platform: 'sms',
                senderNameVarId: '',
                emailVarId: '',
                emailTemplate: '',
                isTemplateIdFromVar: false,
                messageTemplateId: '',
                messageTemplateIdFromVar: '',
                messageTemplateIdConst: '',
                messageTemplateOptions: [],
            } as PipelineStep;
        case 'SET_VAR':
            return {
                type: 'SET_VAR',
                ...common,
                defaultValue: '',
                sourceVarId: '',
                targetVarId: '',
                valueOptions: [],
                operationType: 'map',
                itemToExtract: '',
            } as PipelineStep;
        case 'CREATE_DASHBOARD':
            return {
                type: 'CREATE_DASHBOARD',
                ...common,
                dashboardResourceId: { isFromVar: false, varId: '', constValue: '' },
                respondentGroupName: { isFromVar: false, varId: '', constValue: '' },
                dashboardUrlTargetVarId: '',
                dashboardRefTargetVarId: '',
                dashboardEditTokenTargetVarId: '',
            } as PipelineStep;
        default:
            return { type: 'EMPTY', ...common } as PipelineStep;
    }
}
